<template>
  <div>
    <section-title
      content="Firma de Participantes"
      icon="fas fa-file-user"
      reverse
      bg-icon="orange"
      class="mb-1"
    />
    <span class="font-14 color-gray-6 mb-4">
      Destrezas de autodeterminación, vida diaria, conductas adaptativas,
      aspecto social-emocional, entre otras.
    </span>
    <progress-legend :items="progressLevels" class="mb-3 mt-3" />
    <div
      v-for="(service, key) in items"
      :key="key"
      class="service-item mt-3 rounded"
    >
      <div
        class="d-flex justify-content-between shadow-sm px-3 py-1 mb-2"
        :class="[
          { displayed: service.displayed },
          { rounded: !service.displayed },
          {
            'was-Invalidated':
              validated &&
              service.hasAcademicProgress &&
              service.areas.some((a) =>
                a.objectives.some((o) => !Boolean(o.level?.id))
              ),
          },
        ]"
      >
        <div class="mt-1">
          <a
            data-toggle="collapse"
            :href="`#${serviceItemId(key)}`"
            role="button"
            aria-expanded="false"
            aria-controls="multiCollapseExample1"
            class="service-item-collapse-button text-white rounded-circle mr-2"
            :class="{
              'fas fa-angle-right bg-teal': !service.displayed,
              'fas fa-angle-down bg-success': service.displayed,
            }"
            @click="display(service)"
          ></a>
          <span class="fs-16 font-weight-bold ">
            {{ service.academicYear }} - {{ service.peiId }}
          </span>
        </div>
      </div>
      <div :id="serviceItemId(key)" class="collapse multi-collapse">
        <div class="p-4">
          <div v-for="(area, areaKey) in service.areas" :key="areaKey">
            <span
              class="mb-4 border-gray bg-white fs-16 badge badge-pill py-2 px-4 font-weight-normal"
              :class="[
                {
                  'was-Invalidated rounded-pill':
                    validated &&
                    service.hasAcademicProgress &&
                    area.objectives.some((o) => !Boolean(o.level?.id)),
                },
              ]"
            >
              {{ area.areaName }}
            </span>
            <div
              class="row "
              v-for="(objective, objectiveKey) in area.objectives"
              :key="objectiveKey"
            >
              <div class="col-sm">
                {{ objective.description }}
              </div>

              <div class="col-md-sm ">
                <div
                  style="float: right"
                  class=" rounded d-flex"
                  :class="{
                    'cursor-pointer': !isReadOnly,
                  }"
                >
                  <!-- ksk -->
                  <div
                    v-for="progressLevel in progressLevels"
                    :style="
                      getStyleProgressLevel(service, objective, progressLevel)
                    "
                    :key="`${progressLevel.id}-po-select-id`"
                    @click="
                      service.hasAcademicProgress &&
                        !isReadOnly &&
                        selectLevelOption(
                          key,
                          areaKey,
                          objectiveKey,
                          progressLevel.id,
                          service.academicProgressId,
                          objective.objectiveId,
                          service.peiId
                        )
                    "
                    class="border rounded py-3 text-center my-2 mx-1 px-1"
                  >
                    <span
                      v-if="service.hasAcademicProgress"
                      class="font-weight-bold"
                    >
                      {{ progressLevel.name }}
                    </span>
                    <span v-else>
                      N/A
                    </span>
                  </div>
                  <!-- /ksk -->
                </div>
              </div>
              <div class="col-12">
                <hr style="border: 1px solid #89969117;" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="py-4 d-flex justify-content-end">
      <action-button
        type="button"
        text="Continuar"
        i="fas fa-arrow-alt-circle-right"
        variant="success"
        @click="next"
      />
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import CustomSeparator from 'custom-separator';
import ActionButton from 'ActionButton';
import ProgressLegend from './ProgressLegend';
import peiService from '@/services/pei/peiAcademicProgressCalendar.js';
import transitionStudentApi from '@/services/pei/transitionStudent.js';
export default {
  name: 'FunctionalSkills',
  components: {
    ActionButton,
    ProgressLegend,
    SectionTitle,
    CustomSeparator,
  },
  props: {
    data: {
      type: Object,
      dafault: () => ({}),
    },
    value: {
      type: Object,
      dafault: () => ({}),
    },
    isReadOnly: {
      type: Boolean,
      dafault: () => false,
    },
    weeks: {
      type: Array,
      default: () => [3],
    },
  },
  data: () => ({
    validated: false,
    openLevelOption: null,
    progressLevels: [],
    items: [],
    itemsToSave: [],
  }),
  computed: {
    serviceItemId: () => (key) => `educational-service-collapse-${key}`,
    studentSieId() {
      return this.data.studentSieId;
    },
  },
  methods: {
    getStyleProgressLevel(service, objective, progressLevel) {
      let style = 'width: 50px; height: 63px;';
      let colorStyle = `background-color: ${progressLevel.color};`;

      if (!service?.hasAcademicProgress) {
        colorStyle = 'background-color: rgb(225 225 225); ';

        return `${style} ${colorStyle}`;
      }

      if (objective.level?.id == progressLevel.id) {
        style = `${style} ${colorStyle}`;
      } else {
        style = `${style} ${colorStyle} opacity: 0.2;`;
      }

      return style;
    },
    display(service) {
      service.displayed = !service.displayed;
    },
    selectLevelOption(
      key,
      areaKey,
      objectiveKey,
      progressLevelId,
      academicProgressId,
      objectiveId,
      peiId
    ) {
      let level = this.progressLevels.find((x) => x.id == progressLevelId);
      if (level != null) {
        this.items[key].areas[areaKey].objectives[objectiveKey].level = {
          id: progressLevelId,
          name: level.name,
          color: level.color,
        };
      }
      this.openLevelOption = null;

      this.itemsToSave = this.itemsToSave.filter(
        (x) => x.objectiveId != objectiveId
      );

      this.itemsToSave.push({
        academicProgressId: academicProgressId,
        objectiveId: objectiveId,
        progressLevelId: progressLevelId,
        peiId: peiId,
      });
      this.value = this.itemsToSave;
      this.$emit('input', this.value);
    },
    handleOpenLevelOption(key, areaId, objectiveId) {
      if (
        this.openLevelOption ==
        key.toString() + areaId.toString() + objectiveId.toString()
      ) {
        this.openLevelOption = null;
      } else {
        this.openLevelOption =
          key.toString() + areaId.toString() + objectiveId.toString();
      }
    },
    async validate() {
      this.validated = true;
      // exclude PEIs without academic progress to avoid errors when saving.
      const servicesWithAcademicProgress = this.items.filter(
        (s) => s.hasAcademicProgress
      );
      const valid = servicesWithAcademicProgress
        .flatMap((s) => s.areas)
        .flatMap((a) => a.objectives)
        .every((o) => o.level?.id !== 0);

      return {
        valid,
        message: valid
          ? ''
          : 'Para cada sección del PEI deben estar colocadas las L',
      };
    },
    next() {
      this.$emit('next', this.value);
    },
    async getAcademicProgressLevels() {
      const { data } = await peiService.getAcademicProgressLevels();
      this.progressLevels = data;
    },
  },
  async mounted() {
    this.getAcademicProgressLevels();
    let { data } = await transitionStudentApi.getFunctionalSkills(
      this.studentSieId,
      this.weeks
    );
    this.items = data.map((x) => ({ ...x, displayed: false }));
  },
};
</script>
<style scoped lang="scss">
.border-gray {
  border: 1px solid #aabbb4;
}
.service-item {
  background-color: #efefef;
}
.service-item > div:first-child {
  border-radius: 0.25rem 0.25rem 0px 0px;
}
.service-item > div:nth-child(2) {
  border-radius: 0px 0px 0.25rem 0.25rem;
}
.bg-teal {
  background-color: #3f5b60;
}
.fs-16 {
  font-size: 16px;
}
.service-item-collapse-button {
  height: 24px;
  width: 24px;
  text-align: center;
  padding-top: 2px;
  border: 2px solid white;
  cursor: pointer;
  text-decoration: none;
}
.service-item-progress {
  border: 1px solid;
  border-radius: 25px;
}
.service-item-progress.bg-white-success {
  background-color: #d7fce9;
  border-color: #9dcbab;
}
.service-item-progress.border-teal {
  border-color: #afbfb9;
}

.service-item-collapse-button.fa-check {
  padding-top: 5px !important;
}
.has-error {
  background: #ffebeb;
  border: solid 1px #ff5b5c;
}
.bg-red {
  background-color: #fc5a5b;
}
.bg-pale-blue-green {
  background-color: #aabbb5;
}
.sub-area-badge {
  border: 1px solid;
  border-radius: 25px;
  border-color: #b2c1ba;
}

.goal-key {
  background-color: #ff7058;
  border-radius: 5px 5px 0px 0px;
}
.fs-16 {
  font-size: 16px;
}
.fs-18 {
  font-size: 18px;
}
.cursor-pointer {
  cursor: pointer;
}
.relative {
  position: relative;
}
.absolute {
  position: absolute;
}
.progress-option-container {
  top: 70px;
  z-index: 1;
}
.right-5 {
  right: 9px;
}

.progress-week.selected {
  background-color: #ffebeb;
  border: solid 1px #fcc9c8 !important;
}
.progress-week {
  background-color: #e7efeb;
  border: solid 1px #b5c3bc !important;
}
.progress-week-title {
  border-radius: 5px 5px 0px 0px;
  background-color: #3f5b60;
}
.was-Invalidated {
  border-radius: 4px;
  border: 1px solid #ff0018 !important;
  background-color: #ffebeb !important;
}
</style>
